import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiService } from 'src/app/services/api/api.service';
// import { PageNavigateService } from 'src/app/services/page-navigate/page-navigate.service';
import { SweetalertService } from 'src/app/services/sweetalert/sweetalert.service';

@Component({
  selector: 'service-search',
  templateUrl: './service-search.component.html',
  styleUrls: ['./service-search.component.scss']
})
export class ServiceSearchComponent implements OnInit {

  apiData: any = {};
  strFilter = '';
  isServiceSeeAll = false;
  isContentSeeAll = false;
  @Output() itemClick: EventEmitter<any> = new EventEmitter();

  constructor(
    private api: ApiService,
    private swAlert: SweetalertService,
    private ngxLoading: NgxUiLoaderService,
    // private page: PageNavigateService
  ) { }

  ngOnInit() {
  }

  async filter(dropdown?: any) {
    if(this.strFilter.trim().length > 0) {
      this.ngxLoading.start();
      this.apiData = await this.callServiceList();
      this.ngxLoading.stopAll();
      if(dropdown) {
        dropdown.open();
      }
    }
  }

  callServiceList(): Promise<any> {
    return new Promise<any>((resolve: any) => {
      this.isContentSeeAll = false;
      this.isServiceSeeAll = false;
      this.api.serviceSearchList(this.strFilter).subscribe(res => {
        // console.log(res);
        if (res.Code == 200) {
          resolve(res.Results);
        } else {
          this.swAlert.error('Error', res.Message);
          resolve();
        }
      }, err => {
        resolve();
        console.log(err);
      });
    });
  }

  serviceSeeAll(pageSize = this.apiData.ServiceTotal): Promise<any> {
    return new Promise((resolve: any) => {
      this.api.serviceSearch(this.strFilter, 1, pageSize).subscribe(res => {
        // console.log(res);
        if (res.Code == 200) {
          resolve(res.Results);
        } else {
          this.swAlert.error('Error', res.Message);
          resolve();
        }
      }, err => {
        resolve();
        console.log(err);
      });
    });
  }

  contentSeeAll(pageSize = this.apiData.ContentTotal): Promise<any> {
    return new Promise((resolve: any) => {
      this.api.contentSearch(this.strFilter, 1, pageSize).subscribe(res => {
        // console.log(res);
        if (res.Code == 200) {
          resolve(res.Results);
        } else {
          this.swAlert.error('Error', res.Message);
          resolve();
        }
      }, err => {
        resolve();
        console.log(err);
      });
    });
  }

  getServiceByCode(serviceCode: any): Promise<any> {
    return new Promise((resolve: any) => {
      this.api.getServiceDetail(serviceCode).subscribe(res => {
        if (res.Code == 200) {
          resolve(res.Results);
        } else {
          this.swAlert.error('Error', res.Message);
          resolve();
        }
      }, err => {
        resolve();
        console.log(err);
      });
    });
  }

  async serviceClick(item: any, dropdown: any) {
    let service = await this.getServiceByCode(item.ServiceCode);
    this.itemClick.emit(service);
    dropdown.close();
  }

  async serviceSeeAllClick() {
    this.ngxLoading.start();
    this.isServiceSeeAll = true;
    this.apiData.Service = await this.serviceSeeAll();
    this.ngxLoading.stopAll();
  }

  async contentSeeAllClick() {
    this.ngxLoading.start();
    this.isContentSeeAll = true;
    this.apiData.Content = await this.contentSeeAll();
    this.ngxLoading.stopAll();
  }

  async serviceSeeLessClick() {
    this.ngxLoading.start();
    this.apiData.Service = await this.serviceSeeAll(5);
    this.isServiceSeeAll = false;
    this.ngxLoading.stopAll();
  }

  async contentSeeLessClick() {
    this.ngxLoading.start();
    this.apiData.Content = await this.contentSeeAll(5);
    this.isContentSeeAll = false;
    this.ngxLoading.stopAll();
  }

  async contentClick(item: any, dropdown: any) {
    this.itemClick.emit(item);
    dropdown.close();
  }

}
